import { render } from "./NavigationMenu.vue?vue&type=template&id=99e65a4a"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SanttuLehtinen\\Projektit\\vetera\\vetera-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__